/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { OrganizationApiConfiguration as __Configuration } from '../organization-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultTimezoneInfo } from '../models/list-query-result-timezone-info';
@Injectable({
  providedIn: 'root',
})
class CurrencyService extends __BaseService {
  static readonly GetAllPath = '/api/organization/currencies';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param query undefined
   * @return Success
   */
  GetAllResponse(query?: {}): __Observable<__StrictHttpResponse<ListQueryResultTimezoneInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (query != null) __params = __params.set('query', query.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/currencies`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultTimezoneInfo>;
      })
    );
  }
  /**
   * @param query undefined
   * @return Success
   */
  GetAll(query?: {}): __Observable<ListQueryResultTimezoneInfo> {
    return this.GetAllResponse(query).pipe(
      __map(_r => _r.body as ListQueryResultTimezoneInfo)
    );
  }
}

module CurrencyService {
}

export { CurrencyService }
